import type { FC } from "react";
import { Flex } from "@chakra-ui/react";
import SkeletonBox from "./SkeletonBox";
import SkeletonText from "./SkeletonText";

const SkeletonRadio: FC<{ maxWidth?: string }> = props => (
  <Flex alignItems="center" gap={2.5}>
    <SkeletonBox h="20px" w="20px" borderRadius="50%" />
    <SkeletonText h="20px" {...props} />
  </Flex>
);

const SkeletonRadioGroup: FC = () => (
  <>
    <SkeletonRadio />
    <SkeletonRadio maxWidth="150px" />
    <SkeletonRadio maxWidth="170px" />
    <SkeletonRadio />
  </>
);

export default SkeletonRadioGroup;
